import {
  InquiryTemplate,
  InquiryTemplateAttributes,
  InquiryTemplateRelationships,
  InquiryTemplateStatus,
  InquiryTemplateTier,
} from 'dashboard/models/inquiry-template';
import { ApiModel } from 'lib/interfaces/api';

const createdAt = '2023-01-01T00:00:00.000Z';
const updatedAt = '2023-01-01T00:01:00.000Z';

export function createPreviewInquiryTemplate(
  attributes?: Partial<InquiryTemplateAttributes>,
  relationships?: Partial<InquiryTemplateRelationships>,
  id?: string,
): InquiryTemplate {
  return {
    attributes: {
      'created-at': createdAt,
      'updated-at': updatedAt,
      'latest-published-at': updatedAt,
      name: 'Template version',
      'pricing-tier': InquiryTemplateTier.Basic,
      description: 'Template description',
      'name-display': 'Template display name',
      status: InquiryTemplateStatus.Active,
      'verification-template-ids': [],
      'archived-at': undefined,
      ...attributes,
    },
    id: id || 'itmpl_123',
    type: ApiModel.InquiryTemplate,
    relationships: {
      'latest-published-version': { data: null },
      'latest-draft-version': { data: null },
      ...relationships,
    },
  };
}
